import { Col, Container, Nav, NavItem, NavLink, Row, TabContent, TabPane } from "reactstrap";
import React, { useState, useEffect, Fragment } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { GetCookieToken } from "../Cookie/GetCookie";
import LoadingPage from "../TESTPage/LoadingPage";
import FadeIn from "react-fade-in/lib/FadeIn";
import TimeHistoryTable from "./TimeHistoryTable";
import TimeHistoryEmployeeTable from "./TimeHistoryEmployeeTable";
import WorkEntry from "./WorkEntry";
import SubMenuEntryWork from "./SubMenuEntryWork";
import axios from "axios";
import { CheckSubAdmin } from "../Function/CheckSubAdmin";
import { CheckPosition } from "../Function/CheckPosition";
import classNames from "classnames";
import { useGetPositionConText } from "../Context/PositionContext";
import { useGetPositionSubAdminConTextConText } from "../Context/PositionSubAdminConText";
// import EmployeeView from "./SetUserData/Menu/EmployeeView";

const EntryWork = () => {
  document.title = "ลงเวลาปฏิบัติราชการ | Flexible Time";

  const baseURL = process.env.REACT_APP_API_CORS;
  const token = GetCookieToken("userToken");

  const [userInfo, setUserInfo] = useState([]);
  const [mustEntry, setMustEntry] = useState();
  const [loadingPage, setLoadingPage] = useState(true);
  const [adminViewSubMenu, setAdminViewSubMenu] = useState();
  const [viewSubMenu, setViewSubMenu] = useState();
  const [activeTab, setActiveTab] = useState("1");

  const [hasPermit, setHasPermit] = useState(false)
  const [hasPermitAdmin, setHasPermitAdmin] = useState(false)

  const {position, setPosition} = useGetPositionConText()
  const {positionSubAdmin, setPositionSubAdmin} = useGetPositionSubAdminConTextConText()

  // //////// เรียก UserInfo
  useEffect(() => {
    
    const getUserInfo = async () => {
      try {
        const res = await axios.get(baseURL + "/api/users/info", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setPosition(CheckPosition(res?.data?.result?.position))
        setPositionSubAdmin(CheckSubAdmin(res?.data?.result?.positionSubAdmin))
        setAdminViewSubMenu(CheckSubAdmin(res?.data?.result?.positionSubAdmin))
        setViewSubMenu(CheckPosition(res?.data?.result?.position))
      } catch (err) {
        console.error(err);
      }
    };
    setLoadingPage(true);
      getUserInfo();
    setTimeout(() => {
      setLoadingPage(false);
    }, 1500);
  }, []);

  useEffect(() => {
    const checkViewSubMenu = () => {
      if (viewSubMenu && (viewSubMenu.includes(5) || 
         viewSubMenu.includes(4) || 
         viewSubMenu.includes(3) || 
         viewSubMenu.includes(2) ||
         viewSubMenu.includes(1))) {
           setHasPermit(true)
                   }
     }
     const checkAdminViewSubMenu = () => {
        if (adminViewSubMenu && (adminViewSubMenu.includes(0) || adminViewSubMenu.includes(2))) {
          setHasPermitAdmin(true)
        }
     }
     checkViewSubMenu();
     checkAdminViewSubMenu();
  }, [viewSubMenu])

  /////// เช็คว่าต้องลงเวลาเข้างานไหม
  // const isMustEntryWork = (positionArr) => {
  //   if (!positionArr) return true;
  //   else if (positionArr?.length === 0) return true;
  //   else {
  //     const result = positionArr?.some((item) => {
  //       if (
  //         item?.is_default === 1 &&
  //         item?.position_id <= 8 &&
  //         item?.position_id >= 6
  //       )
  //         return true;
  //       if (
  //         item?.is_default === 1 &&
  //         item?.position_id >= 1 &&
  //         item?.position_id <= 5
  //       )
  //         return false;
  //     });
  //     return result;
  //   }
  // };
  const isMustEntryWork = (positionArr) => {
    if (
      positionArr?.find(
        (item) => item?.position_id >= 1 && item?.position_id <= 5 && item?.assign !== 1
      )
    )
      return false;
    else return true;
  };

  //////// ทำงาน isMustEntryWork ตาม UserInfo
  useEffect(() => {
    const letEffect = async ()=>{
       setMustEntry(await isMustEntryWork(userInfo?.position));
    }
    letEffect()
  }, [userInfo]);

  // useEffect(() => {
  //   setViewSubMenu(
  //     CheckSubAdmin(userInfo?.positionSubAdmin) ||
  //       CheckPosition(userInfo?.position)
  //   );
  // }, [userInfo]);

  const toggle = tab => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <div className="page-content">
      {
      (loadingPage) ? 
        (<LoadingPage />)
       : (
        <FadeIn>
          <Container fluid>
            <SubMenuEntryWork/>
            <Breadcrumbs
              title="หน้าหลัก"
              breadcrumbItem="ลงเวลาปฏิบัติราชการ"
              home={true}
            />
            <Row>
              {/* {mustEntry ? (
                <>
                  <Col xxl={4} xs={12}>
                    <WorkEntry />
                  </Col>
                  <Col xxl={8} xs={12}>
                    <TimeHistoryTable />
                  </Col>
                </>
              ) : (
                <Col xxl={12} xs={12}>
                  <TimeHistoryEmployeeTable />
                </Col>
              )} */}
              {hasPermit ?
                  <Col xxl={12} xs={12} className="px-0"> <TimeHistoryEmployeeTable /> </Col>
                : hasPermitAdmin ? 
                  <Fragment>
                    <Nav tabs>
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classNames({
                                active: activeTab === "1",
                              })}
                              onClick={() => {
                                toggle("1");
                              }}
                            >
                              <h5>
                                {activeTab === "1" ? <i className="fa-solid fa-user font-size-18 me-2"></i> : ""}
                                ตนเอง
                              </h5>
                            </NavLink>
                          </NavItem>
                          
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classNames({
                                active: activeTab === "2",
                              })}
                              onClick={() => {
                                toggle("2");
                              }}
                            >
                              <h5>
                                {activeTab === "2" ? <i className="fa-duotone fa-users font-size-18 me-2"></i> : ""}  
                                เจ้าหน้าที่
                              </h5>
                            </NavLink>
                          </NavItem>
                    </Nav>
                    <TabContent activeTab={activeTab}>
                      <TabPane tabId="1" className="px-0">
                        <Row className="mt-2">
                          <Col xxl={4} xs={12} className="ps-0">
                            <WorkEntry />
                          </Col>
                          <Col xxl={8} xs={12} className="pe-0">
                            <TimeHistoryTable />
                          </Col>
                        </Row>
                      </TabPane>
                      <TabPane tabId="2">
                        <Row className="mt-2">
                          <Col xxl={12} xs={12} className="px-0">
                            <TimeHistoryEmployeeTable />
                          </Col>
                        </Row>
                      </TabPane>
                    </TabContent>
                  </Fragment>
                : 
                  <Fragment>
                    <Col xxl={4} xs={12} className="ps-0">
                        <WorkEntry />
                    </Col>
                    <Col xxl={8} xs={12} className="pe-0">
                      <TimeHistoryTable />
                    </Col>
                  </Fragment>
               }
                  
            </Row>
          </Container>
        </FadeIn>
      )
      }
    </div>
  );
};

export default EntryWork;
